export default {
    namespaced: true,

    state: {
        version: null,
        endpointOverrideCode: '4266759',
        endpointIsOverriden: false,
        endpointOverrideUrl: null,
        showSearch: false,
        showFilters: false,
        isPolling: false
    },

    getters: {
        getVersionNumber(state) {
            return state.version
        },
        getEndpointOverrideCode(state) {
            return state.endpointOverrideCode
        },
        getEndpointIsOverridden(state) {
            return state.endpointIsOverriden
        },
        getEndpointOverrideUrl(state) {
            return state.endpointOverrideUrl
        },
        getShowSearch(state) {
            return state.showSearch
        },
        getShowFilters(state) {
            return state.showFilters
        },
        getIsPolling(state) {
            return state.isPolling
        }
    },

    mutations: {
        PUSH_VERSION_NUMBER(state, data) {
            state.version = data
        },
        SET_ENDPOINT_IS_OVERRIDDEN(state, data) {
            state.endpointIsOverriden = data
        },
        SET_ENDPOINT_OVERRIDE_URL(state, data) {
            state.endpointOverrideUrl = data
        },
        SET_SHOW_SEARCH(state, data) {
            state.showSearch = data
        },
        SET_SHOW_FILTERS(state, data) {
            state.showFilters = data
        },
        SET_POLLING(state, data) {
            state.isPolling = data
        }
    },

    actions: {
        async setEndpointUrl({commit}, data) {
            commit('SET_ENDPOINT_OVERRIDE_URL', data)
        },
        async setShowSearch({commit}, data) {
            commit('SET_SHOW_SEARCH', data)
        },
        async setShowFilters({commit}, data) {
            commit('SET_SHOW_FILTERS', data)
        },
        async setIsPolling({commit}, data) {
            commit('SET_POLLING', data)
        }
    }
}